import { privateFetch } from "../../utils/CustomFetch";
import { CONSTANT } from "../../utils/Constant";

export const SVLeadTagRequest = async (page, size ) => {
    let responseData = []
    await privateFetch.get(`maintenance/leads-tags?page=${page}&size=${size}`, {
        headers: {
            ...CONSTANT.HEADER_TYPE,
        },
    })
    .then(async (response)=> {
        responseData = await response.data
    }).catch((error)=> {
        throw new Error (error)
    });

    return responseData
}

export const SVLeadTagSaveRequest = async (data) => {
    try {
        const response = await privateFetch.post('maintenance/leads-tags', {
            name: data.name
        }, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const SVLeadTagUpdatedRequest = async (data) => {
    try {
        const response = await privateFetch.put(`maintenance/leads-tags/${data.id}`,
        {
            name: data.name
        }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
}

export const SVLeadTagDelete = async (id) => {
    try {
        const response = await privateFetch.delete(`maintenance/leads-tags/${id}`, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        if ( response.status === 200) {
            return response.data.message;
        } else {
            throw new Error("Error al eliminar.");
        }
    } catch (error) {
        throw error;
    }
}
